import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import bookmarkLine from '../images/bookmark-line.svg';
import bookmarkSolid from '../images/bookmark-filled.svg';
import searchLine from '../images/search-line.svg';
import searchSolid from '../images/search-filled.svg';
import statsLine from '../images/stats-line.svg';
import statsSolid from '../images/stats-filled.svg';
import userLine from '../images/user-line.svg';
import userSolid from '../images/user-filled.svg';
import { useTranslation } from '../i18n';

function NavbarApp() {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;

  const activeLink = (path) => {
    for (let i = 0; i < path.length; i++) {
      if (path[i] === pathname) {
        return true;
      }
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link
          className={
            activeLink(['/books', '/', '/index.html'])
              ? 'nav-link active'
              : 'nav-link'
          }
          to="/books"
        >
          <img
            className="nav-icon"
            height={24}
            width={24}
            src={
              activeLink(['/books', '/', '/index.html'])
                ? bookmarkSolid
                : bookmarkLine
            }
            alt=""
          />
          <span className="nav-label">{t.mybooks}</span>
        </Link>
        <Link
          className={activeLink(['/search']) ? 'nav-link active' : 'nav-link'}
          to="/search"
        >
          <img
            className="nav-icon"
            height={24}
            width={24}
            src={activeLink(['/search']) ? searchSolid : searchLine}
            alt=""
          />
          <span className="nav-label">{t.findbook}</span>
        </Link>
        <Link
          className={activeLink(['/stats']) ? 'nav-link active' : 'nav-link'}
          to="/stats"
        >
          <img
            className="nav-icon"
            height={24}
            width={24}
            src={activeLink(['/stats']) ? statsSolid : statsLine}
            alt=""
          />
          <span className="nav-label">{t.stats}</span>
        </Link>
        <Link
          className={activeLink(['/account']) ? 'nav-link active' : 'nav-link'}
          to="/account"
        >
          <img
            className="nav-icon"
            height={24}
            width={24}
            src={activeLink(['/account']) ? userSolid : userLine}
            alt=""
          />
          <span className="nav-label">{t.account}</span>
        </Link>
      </div>
    </nav>
  );
}

export default NavbarApp;
